module.exports = __webpack_public_path__ + "static/img/protfolio_bg.3693d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/protfolio_bg.jpg
// module id = qztS
// module chunks = 0